import React, { Component } from "react";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ textAlign: "center", margin: "30px 0 0" }}>
          <Typography variant="h3" component="div" gutterBottom>
            Please check your Application logs
          </Typography>
          <Typography variant="body1" gutterBottom>
            Try again after sometime..
          </Typography>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorBoundary;
